'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';

export function Navbar() {
  return (
    <nav className="sticky top-0 z-40 bg-[#D71920] shadow-lg border-b border-[#B01017]">
      <div className="container mx-auto flex items-center justify-center px-4 py-4">
        {/* Desktop Navigation - Centered */}
        <div className="hidden md:flex items-center gap-8">
          <Link
            href="/"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            Home
          </Link>
          <Link
            href="/order"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            Order
          </Link>
          <a
            href="/menu"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            Menu
          </a>
          <Link
            href="/about"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            About Mo
          </Link>
          <Link
            href="/catering"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            Catering
          </Link>
          <a
            href="https://www.instagram.com/mosburgerdmv/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
          >
            Location Updates
          </a>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="md:hidden border-t border-[#B01017] bg-[#D71920] px-4 py-3">
        <div className="flex justify-between items-center overflow-x-auto">
          <Link href="/" className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2">
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">Home</span>
          </Link>
          <Link href="/order" className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2">
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">Order</span>
          </Link>
          <a href="/menu" className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2">
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">Menu</span>
          </a>
          <a href="https://www.instagram.com/mosburgerdmv/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2">
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">Location</span>
          </a>
          <Link
            href="/about"
            className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2"
          >
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">About Mo</span>
          </Link>
          <Link
            href="/catering"
            className="flex flex-col items-center gap-1 hover:text-white/80 transition-colors group flex-shrink-0 border border-white/20 rounded-lg px-3 py-2"
          >
            <span className="text-xs font-semibold text-white group-hover:text-white/80 whitespace-nowrap">Catering</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}
